<app-sidebar></app-sidebar>
<div class="horizontal-menu horizontal-app-menu dashboard">
    <app-header></app-header>
    <div class="page-container pl-5" *ngIf="permisoUsuario">
        <div class="page-content-wrapper ">
            <div class="content sm-gutter">
                <div class="container sm-padding-10 p-t-20 p-l-0 p-r-0" *ngIf="solicitud">
                    <div class="row">
                        <app-archivos-expediente class="full-width" [numSolicitud]="numSolicitud" [claveTipoSolicitud]="claveTipoSolicitud"></app-archivos-expediente>
                    </div>
                    <div class="row">
                        <div class="col-lg-7">
                            <app-contrato-pagare [numContrato]="solicitud.credito.numContrato" [numSolicitud]="numSolicitud"></app-contrato-pagare>
                            <app-detalle-cliente [idNegocio]="solicitud.negocio.idNegocio"></app-detalle-cliente>
                        </div>
                        <div class="col-lg-5">
                            <app-datos-generales-solicitud [solicitud]="solicitud"></app-datos-generales-solicitud>
                            <app-tracking-solicitud [tracking]="tracking"></app-tracking-solicitud>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <app-footer></app-footer>
</div>